<template>
  <div>
    <el-tabs v-model="activeTab" type="border-card" tab-position="top">
      <el-tab-pane v-for="(booking, index) in info" :disabled="lockToZero && index !== 0" :name="String(index)" :key="`roomTab-${index}`">
        <template slot="label">
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 13px;" :style="currentStep === 2 && lockToZero ? { cursor: 'not-allowed' } : {}">
            <div>{{ booking.stayRange || displayStayRange(booking) }}</div>
            <div>
              <span>{{ bookingRoomNames(booking.selectedRoom) }}</span>
            </div>
            <el-tag v-if="mode === 'edit'" :type="index === 0 ? 'success' : 'danger'" size="small" style="border-radius: 8px">{{ index === 0 ? '建單中' : '已建立不可修改' }}</el-tag>
            <HotelOrderStatusTag v-else-if="showStatusOnTabs && booking.status" :status="booking.status" class="accommodation-tab-status" />
          </div>
        </template>
        <div v-for="room in booking.selectedRoom" style="background-color:#F9F9FB;margin-bottom:12px;padding: 16px 10px; border-radius: 8px;">
          <span style="font-size:16px; font-weight: 500;color:#121931 ;">{{ room.name }} ({{ nightLabel(room.date.length) }}) </span>
          <span style="font-size:12px; color:#6C6B6B">{{ room.category }}</span>
          <div style="margin-top: 8px; display: flex; gap: 12px; flex-wrap: wrap;">
            <el-tag v-for="date in room.date" :key="date.day" type="info" color="#E5E7EB" size="medium" style="color: #121931; border-radius: 8px;">
              {{ date.day }}
            </el-tag>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatHotelStayRange, formatStayNightLabel } from '@utils/format-hotel-stay'
import HotelOrderStatusTag from './HotelOrderStatusTag.vue'

export default {
  name: 'AccommodationListPartial',
  components: {
    HotelOrderStatusTag,
  },
  props: {
    info: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    mode: {
      type: String,
      default: 'view', //'view'|'edit'
    },
  },
  data() {
    return {
      activeTab: '0',
      lockToZero: true,
    }
  },
  watch: {
    // 當內部 activeTab 改變時，發出事件讓父元件可以同步切換顯示（例如 pets 列表）
    activeTab(newVal) {
      // emit 數字型態的 index
      this.$emit('tab-change', Number(newVal))
    },
    info: {
      handler() {
        this.activeTab = '0'
      },
    },
    currentStep: {
      immediate: true,
      handler(val) {
        if (val === 2 && this.lockToZero) {
          this.activeTab = '0'
        } else {
          this.lockToZero = false
        }
      },
    },
  },
  computed: {
    ...mapGetters('hotel/setting', ['showCheckoutDate']),
    showStatusOnTabs() {
      return this.mode === 'view' && Array.isArray(this.info) && this.info.length > 1
    },
  },
  methods: {
    nightLabel(count) {
      return formatStayNightLabel(count, this.showCheckoutDate)
    },
    displayStayRange(booking) {
      if (booking.stayRange) return booking.stayRange

      if (booking.checkInDate && booking.checkOutDate) {
        return formatHotelStayRange({
          checkInDate: booking.checkInDate,
          checkoutDate: booking.checkOutDate,
          nights: booking.nights,
          showCheckoutDate: this.showCheckoutDate,
        })
      }

      const bookingDates = (booking.selectedRoom || []).flatMap((room) =>
        (room.date || []).map((item) => String(item.day || '').replace(/\//g, '-'))
      )

      if (bookingDates.length > 0) {
        return formatHotelStayRange({ bookings: bookingDates, showCheckoutDate: this.showCheckoutDate })
      }

      return ''
    },
    bookingRoomNames(rooms) {
      if (!rooms || rooms.length === 0) return ''
      // 取前二個房間名稱
      const names = rooms.map((room) => room.name)
      if (names.length <= 2) {
        return names.join('＆')
      } else {
        return names.slice(0, 2).join('＆') + '...'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs.el-tabs--border-card .el-tabs__item:not([id='tab-byOrder']):not([id='tab-bySize']) {
  height: 92px;
  line-height: 1.8;
  display: inline-flex;
}
::v-deep .accommodation-tab-status.el-tag {
  height: 24px;
  line-height: 22px;
  padding: 0 8px;
  font-size: 12px;
  border-radius: 8px;
  margin-top: 2px;
  box-sizing: border-box;
}
::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0 30px;
  align-items: center;
  display: flex;
}
::v-deep .el-tabs__nav-prev,
::v-deep .el-tabs__nav-next {
  font-size: 20px;
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  background-color: #eeeeee;
  border: none;
  &.is-active {
    background-color: #ffffff;
  }
}
::v-deep .el-tabs.el-tabs--border-card > .el-tabs__content {
  background-color: #ffffff;
  margin-top: 0px;
}

::v-deep .el-tab-pane {
  background-color: #ffffff !important;
  padding: 0;
}
</style>
